import { ReducerAction, ReducerHandler } from '../../Types';
import { StoreIncidents } from '../../Types/StoreTypes';
import { SET_INCIDENTS } from '../Actions/openAIIncidentsActions';

const initialState = {
    incidents: [],
    hasIncidents: false,
} as StoreIncidents;

const openAIIncidentsReducerMap: Record<string, ReducerHandler<StoreIncidents>> = {
    [SET_INCIDENTS]: (state, action) => ({
        ...state,
        incidents: action.payload,
        hasIncidents: action.payload.length > 0,
    }),
};

function openAIIncidentsReducer(state = initialState, action: ReducerAction): StoreIncidents {
    const handler = openAIIncidentsReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default openAIIncidentsReducer;
